/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Chat_Own_DocumentsInputs */



/**
* | output |
* | --- |
* | "Chat with one of my documents" |
*
* @param {Uno_Welcome_Suggestion_Chat_Own_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_chat_own_documents = /** @type {((inputs?: Uno_Welcome_Suggestion_Chat_Own_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Chat_Own_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit einem meiner Dokumente chatten")
	return /** @type {LocalizedString} */ ("Chat with one of my documents")
});